import React from "react";
import PrimaryButton from "../../components/buttons/PrimaryButton";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { event } from "../../components/reactGA";
import config from "../../Config";
import PageHeader from "../PageHeader";
import i18n from "../../i18n";

class DataSaver extends React.Component {
	componentWillMount(){
		if(window && window.navigator && window.navigator.connection && !window.navigator.connection.saveData){
			event({
                category:"Data Saver Page",
                action: "Date Saver Disabled"
            });
			this.props.history.push("/play/");
		} else {
			event({
                category:"Data Saver Page",
                action: "Date Saver Enabled"
            });
		}
	}

	render(){
		var isOpera =(window.navigator.userAgent.indexOf("Opera") || window.navigator.userAgent.indexOf('OPR')) != -1; 
		var isChrome = window.navigator.userAgent.indexOf("Chrome") != -1;
		// console.log("isOpera -->>",isOpera) 
		// console.log("isChrome -->>",isChrome)
	
		var browserName = "Google Chrome";
		var step1 =  <span>Click on <MoreVertIcon style={{fontSize:12}}/> in the top right</span>;
		var step3 = "Click on Data Saver"
		if(isOpera){
			browserName = "Opera";
			step1 = "Click on right bottom “O”";
			step3 = "Select data saving mode"
		}
		return <div className="wrapper">
			<PageHeader 
                backLocation="/play/" 
                label={i18n.t("Data Saver")}
            />
			<div className="card montserratRegular">
				<h3>Please turn off the Data Saver mode of your browser to continue.</h3>
				<h4>For {browserName}:</h4>
				<br/>                
				<div>
					Step 1: {step1}
			        <br />
			        Step 2: Go to Settings
			        <br />
			        Step 3: {step3}
			        <br />
			        Step 4: Turn it off
			        <br />
			        Step 5: Reload the page
				</div> 
				<br/>
		    		For other browsers, please switch off from the Settings menu.
		        <br/>
		        	if you still wish to login click on login button.
		        <br/>
		    	<br/>
		        <div style={{display:'flex',justifyContent: 'space-evenly'}} className="text-center">
		        	<PrimaryButton
		        		label="Reload"
		        		onClick={()=> window.location.reload(true)}
		        	/>
		        	<PrimaryButton
		        		label="Login"
		        		onClick={()=> window.location.href = `${config.BILLING_URL}/login`}
		        	/>
		        </div>               
			</div>
		</div>
	}
}

export default DataSaver;



// WEBPACK FOOTER //
// ./src/views/DataSaver/index.js